import {
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import Layer from '@arcgis/core/layers/Layer';
import MapView from '@arcgis/core/views/MapView';
import { DestroyBase } from '../../../../../shared/base-classes/destroy-component-base';
import { takeUntil } from 'rxjs';
import { MapViewService } from '../../../services/arcgis/map-view.service';
import LayerList from '@arcgis/core/widgets/LayerList.js';
import Legend from '@arcgis/core/widgets/Legend.js';

@Component({
  selector: 'app-site-toolkit-feature-info',
  standalone: true,
  imports: [],
  templateUrl: './site-toolkit-feature-info.component.html',
  styleUrl: './site-toolkit-feature-info.component.scss',
})
export class SiteToolkitFeatureInfoComponent
  extends DestroyBase
  implements OnInit
{
  public featureLayers!: Layer[];
  isLoading = true;

  @ViewChild('layerList', { static: true })
  private layerListDiv!: ElementRef<HTMLDivElement>;
  @ViewChild('layerListLegend', { static: true })
  private layerListLegendDiv!: ElementRef<HTMLDivElement>;

  mapViewService = inject(MapViewService);

  ngOnInit(): void {
    this.mapViewService.mapView$
      .pipe(takeUntil(this.destroy$))
      .subscribe((mapView: MapView | null) => {
        if (mapView === null) {
          this.featureLayers = [];
          this.isLoading = false;
          return;
        }
        this.featureLayers = mapView.map?.layers
          .filter((layer) => layer.type === 'feature')
          .toArray();

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _layerList = new LayerList({
          view: mapView,
          container: this.layerListDiv.nativeElement,
        });
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const _legend = new Legend({
          view: mapView,
          container: this.layerListLegendDiv.nativeElement,
        });

        this.isLoading = false;
      });
  }
}
